// extracted by mini-css-extract-plugin
export var button = "_7h-0";
export var icon = "_7h-1";